import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ControlService } from 'src/app/shared/control.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
})
export class TimerComponent implements OnInit {
  @ViewChild('failedTaskHelper') failedTaskHelper: TemplateRef<any>;
  @ViewChild('completedTaskHelper') completedTaskHelper: TemplateRef<any>;
  @Input() seconds: number;
  @Output() finished: EventEmitter<boolean> = new EventEmitter<boolean>();
  start = false;
  failed = false;
  interval;

  constructor(
    private controlService: ControlService,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {}

  startTimer() {
    this.start = true;
    this.interval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
        this.cd.detectChanges();
      } else {
        this.seconds = 0;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  failedTask() {
    const failedCounter = this.controlService.failedCounter.value + 1;
    this.controlService.failedCounter.next(failedCounter);
    this.snackBar.openFromTemplate(this.failedTaskHelper, { duration: 3200, });
    this.finishTask();
  }

  completeTask() {
    this.snackBar.openFromTemplate(this.completedTaskHelper, { duration: 3200, });
    this.finishTask();
  }

  finishTask() {
    this.start = false;
    clearInterval(this.interval);
    this.finished.emit(true);
  }

}
